export enum SIZES {
    SMALL = "sm",
    MEDIUM = "md",
    LARGE = "lg",
    XLARGE = "xl",
    XXLARGE = "2xl"
}